import script from "./CourseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseView.vue?vue&type=script&lang=ts&setup=true"

import "./CourseView.vue?vue&type=style&index=0&id=5940c3f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5940c3f8"]])

export default __exports__